// https://www.pinterest.com/ohjoy
export const pinterestProfileFullURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?pinterest\.[a-z]{2,3}\/([^\s/?#]+)/;
// https://www.pinterest.com/ohjoy/recipes
export const pinterestBoardFullURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?pinterest\.[a-z]{2,3}\/([^\s/?#]+)\/([^\s#/?<!_]+)/;
// ohjoy/recipes
export const pinterestBoardShortURLRegExp = /((?!@.*$).*)\/([^?#/?<!_]+)\/?/;
